import React from 'react';
import { useTranslation } from 'react-i18next';

import { IPricing } from 'types/interfaces/IPricing';
import { ISCBPricing } from 'types/interfaces/sulu/IContentBlocks';

import Pricing from './Pricing';

const EasyAssessor = (props: ISCBPricing) => {
  const { t } = useTranslation();

  const pricingData: IPricing = {
    ...props,
    items: [
      {
        headline: t('components.pricing.easyAssessor.pricing.headline'),
        subline: t('components.pricing.easyAssessor.pricing.subline'),
        costs: [
          {
            numberOfPeople: t(
              'components.pricing.easyAssessor.pricing.costs.item1.price',
            ),
            price: t(
              'components.pricing.easyAssessor.pricing.costs.item1.numberOfPeople',
            ),
          },
          {
            numberOfPeople: t(
              'components.pricing.easyAssessor.pricing.costs.item2.price',
            ),
            price: t(
              'components.pricing.easyAssessor.pricing.costs.item2.numberOfPeople',
            ),
          },
          {
            numberOfPeople: t(
              'components.pricing.easyAssessor.pricing.costs.item3.price',
            ),
            price: t(
              'components.pricing.easyAssessor.pricing.costs.item3.numberOfPeople',
            ),
          },
          {
            numberOfPeople: t(
              'components.pricing.easyAssessor.pricing.costs.item4.price',
            ),
            price: t(
              'components.pricing.easyAssessor.pricing.costs.item4.numberOfPeople',
            ),
          },
        ],
      },
      {
        headline: t('components.pricing.easyAssessor.oneTimeCharge.headline'),
        subline: t('components.pricing.easyAssessor.oneTimeCharge.subline'),
        costs: [
          {
            numberOfPeople: t(
              'components.pricing.easyAssessor.oneTimeCharge.costs.item1.price',
            ),
            price: t(
              'components.pricing.easyAssessor.oneTimeCharge.costs.item1.numberOfPeople',
            ),
          },
          {
            numberOfPeople: t(
              'components.pricing.easyAssessor.oneTimeCharge.costs.item2.price',
            ),
            price: t(
              'components.pricing.easyAssessor.oneTimeCharge.costs.item2.numberOfPeople',
            ),
          },
        ],
      },
    ],
  };

  return <Pricing {...pricingData} />;
};

export default EasyAssessor;
